import { api } from './client';
import type { OperatorLookupDto, TeamDto, UnitDto } from '../types/admin';

/** Scoped org lookups for filter dropdowns (only what the current user may see). */
export const lookupsApi = {
  units: () => api.get<UnitDto[]>('/lookups/units').then((r) => r.data),
  teams: () => api.get<TeamDto[]>('/lookups/teams').then((r) => r.data),
  operators: () => api.get<OperatorLookupDto[]>('/lookups/operators').then((r) => r.data),
};
